const languageToRegionMap: Record<string, string> = {
  en: "GB",
  eu: "EU",
  es: "ES",
  it: "IT",
  fr: "FR",
  de: "DE",
  us: "US",
  row: "AU",
};

export function getLanguageCode(lang: string): string {
  return languageToRegionMap[lang] || "GB";
}
